/* Shared by product templates and reloaded Shopify editor sections. */
(() => {
  function init(root) {
    root.querySelectorAll('.kenze-product-recovery').forEach((section) => {
      const main = section.querySelector('[data-main-media]');
      const thumbs = [...section.querySelectorAll('.kenze-product-recovery__thumb')];
      if (!main || thumbs.length < 2 || main.dataset.swipeReady) return;
      main.dataset.swipeReady = 'true';
      let active = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
      function select(index) {
        index = ((index % thumbs.length) + thumbs.length) % thumbs.length;
        const thumb = thumbs[index];
        const template = section.querySelector(`template[data-gallery-media="${thumb.dataset.mediaId}"]`);
        if (!template || index === active) return;
        main.querySelectorAll('video').forEach((video) => video.pause());
        main.replaceChildren(template.content.cloneNode(true));
        active = index;
        thumbs.forEach((item, i) => {
          item.classList.toggle('is-active', i === active);
          item.setAttribute('aria-pressed', String(i === active));
        });
        const strip = thumb.parentElement;
        const box = thumb.getBoundingClientRect();
        const bounds = strip.getBoundingClientRect();
        if (box.left < bounds.left || box.right > bounds.right) {
          strip.scrollBy({left: box.left - bounds.left - (bounds.width - box.width) / 2,
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        }
      }
      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => select(index)));
      section.querySelector('[data-gallery-prev]')?.addEventListener('click', () => select(active - 1));
      section.querySelector('[data-gallery-next]')?.addEventListener('click', () => select(active + 1));
      let gesture = null;
      main.addEventListener('pointerdown', (event) => {
        if (!event.isPrimary) { gesture = null; return; }
        if (event.pointerType === 'mouse' || !main.querySelector(':scope > img')) return;
        gesture = {id: event.pointerId, x: event.clientX, y: event.clientY};
        main.setPointerCapture(event.pointerId);
      });
      main.addEventListener('pointerup', (event) => {
        if (!gesture || gesture.id !== event.pointerId) return;
        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        gesture = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy) * 1.3) return;
        select((active + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length);
      });
      main.addEventListener('pointercancel', () => { gesture = null; });
      main.addEventListener('lostpointercapture', () => { gesture = null; });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
